module.exports = __webpack_public_path__ + "img/2-9.21687868.png";